import React from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'

import styles from './ContextualController.module.sass'
import { useFetchList } from 'store'
import { TrustNotification } from 'models'
import Collection from '@jimmyboys/liita-ui/dist/components/Collection'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const StatsRow = (props) => {
	const { data, ...attributes } = props
	return (
		<div {...attributes} className={styles['row']}>
			<h5>{data?.label}</h5>
			<small>{data?.total || 0}</small>
		</div>
	)
}

const ContextualNotificationsController = () => {
	const { i18n } = useGlobal()
	const location = useLocation()
	const [queryParams] = useQueryParams(location)
	const qs = queryString.stringify(queryParams)

	const notificationUri = `/notifications${qs ? `?${qs}` : ''}`
	const { contents } = useFetchList(
		[notificationUri],
		[TrustNotification.fromJSON]
	)
	const [notificationsData] = contents
	const unread = (notificationsData || []).reduce(
		(acc, n) => acc + (!n.isRead ? 1 : 0),
		0
	)
	const read = (notificationsData?.length || 0) - unread

	const data = [
		{ label: i18n`Unread`, total: unread },
		{ label: i18n`Read`, total: read },
		{ label: i18n`Total`, total: notificationsData?.length || 0 },
	]
	return (
		<>
			<Widget
				className={styles['welcome-widget']}
				paddings={['small', '', '']}
			>
				<h2 className={styles['welcome-title']}>{i18n`Info`}</h2>
				<small>{i18n`Notifications and comments.`}</small>
			</Widget>
			<ExpandableWidget
				className={styles['aside-widget']}
				titleAppearance='aside-widget'
				heading='h5'
				title={i18n`Notifications counts`}
				expanded
				icon={'messages'}
				borderRadius
				margins={['small', '', '']}
				paddings={['', 'xsmall', 'xsmall']}
			>
				<Widget className={styles['aside-widget-content']}>
					<div className={styles['list-header']}>
						<h5>&nbsp;</h5>
						<small>{i18n`No.`}</small>
					</div>
					<Collection itemsHeight={42} card={StatsRow} items={data} />
				</Widget>
			</ExpandableWidget>
		</>
	)
}

export default ContextualNotificationsController
